var map = {
	"./aquarius.png": "WcH6",
	"./aries.png": "7xGW",
	"./cancer.png": "q9db",
	"./capricorn.png": "buq1",
	"./gemini.png": "6gt9",
	"./leo.png": "a/F/",
	"./libra.png": "UhS5",
	"./pisces.png": "W+xO",
	"./sagittarius.png": "xTRU",
	"./scorpio.png": "4cK5",
	"./taurus.png": "Xr8J",
	"./virgo.png": "KA/R"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MOQ2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/astrology/zodiac ^\.\/.*\.png$
// module id = MOQ2
// module chunks = 0